import { memo, useCallback } from 'react';
import { callIfPossible } from 'UIComponents/core/Functions';
import ContentTypeaheadContainer from './ContentTypeAheadContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ContentContainer({
  onClickManageButton,
  onInsertContent,
  portalId,
  PopoverErrorState,
  PopoverEmptyState,
  Header,
  searchPlaceHolder,
  search,
  transformData,
  onlyRenderContent = false,
  onViewInsertMenu,
  manageUrl,
  titleMessage,
  getNewLinkUrl,
  CustomItemComponent,
  contentKey
}) {
  function ContentContainerContents({
    onContentChange
  }) {
    return /*#__PURE__*/_jsxs("div", {
      style: {
        minHeight: 300
      },
      children: [Header && /*#__PURE__*/_jsx(Header, {
        portalId: portalId,
        onClickManageButton: onClickManageButton,
        onViewInsertMenu: onViewInsertMenu,
        manageUrl: manageUrl,
        titleMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: titleMessage
        }),
        getNewLinkUrl: getNewLinkUrl
      }), /*#__PURE__*/_jsx(ContentTypeaheadContainer, {
        ErrorState: PopoverErrorState,
        EmptyState: PopoverEmptyState,
        onChange: onContentChange,
        portalId: portalId,
        search: search,
        transformData: transformData,
        searchPlaceHolder: searchPlaceHolder,
        CustomItemComponent: CustomItemComponent,
        contentKey: contentKey
      })]
    });
  }
  const MemoizedContentContainerContents = /*#__PURE__*/memo(ContentContainerContents);
  function ContentComponent({
    insertContent,
    onClose
  }) {
    const handleContentChange = useCallback(({
      id,
      htmlBody
    }) => {
      onInsertContent({
        fromPopover: true
      });
      insertContent({
        id,
        htmlBody
      });
      callIfPossible(onClose);
    }, [onClose, insertContent]);
    const renderContent = () => {
      return /*#__PURE__*/_jsxs("div", {
        style: {
          minHeight: 300
        },
        children: [Header && /*#__PURE__*/_jsx(Header, {
          portalId: portalId,
          onClickManageButton: onClickManageButton,
          onViewInsertMenu: onViewInsertMenu,
          manageUrl: manageUrl,
          titleMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: titleMessage
          }),
          getNewLinkUrl: getNewLinkUrl
        }), /*#__PURE__*/_jsx(ContentTypeaheadContainer, {
          ErrorState: PopoverErrorState,
          EmptyState: PopoverEmptyState,
          onChange: handleContentChange,
          portalId: portalId,
          search: search,
          transformData: transformData,
          searchPlaceHolder: searchPlaceHolder,
          contentKey: contentKey
        })]
      });
    };

    //TODO Looks like this part is used for the SalesEngagementConfig somewhere but not any of ours. Can I delete it?
    if (onlyRenderContent) {
      return renderContent();
    }
    return /*#__PURE__*/_jsx(MemoizedContentContainerContents, {
      onContentChange: handleContentChange
    });
  }
  return ContentComponent;
}
export const ContentContainerV2 = ({
  onInsertContent,
  onSearchChange,
  portalId,
  PopoverErrorState,
  PopoverEmptyState,
  Header,
  searchPlaceHolder,
  search,
  transformData,
  CustomItemComponent,
  contentKey
}) => {
  const ContentComponent = /*#__PURE__*/memo(({
    insertContent,
    onClose
  }) => {
    const handleContentChange = useCallback(({
      id,
      htmlBody,
      version
    }) => {
      onInsertContent({
        fromPopover: true
      });
      insertContent({
        id,
        htmlBody,
        version
      });
      callIfPossible(onClose);
    }, [onClose, insertContent]);
    return /*#__PURE__*/_jsxs("div", {
      style: {
        minHeight: 322
      },
      children: [Header, /*#__PURE__*/_jsx(ContentTypeaheadContainer, {
        CustomItemComponent: CustomItemComponent,
        ErrorState: PopoverErrorState,
        EmptyState: PopoverEmptyState,
        onChange: handleContentChange,
        onSearchChange: onSearchChange,
        portalId: portalId,
        search: search,
        transformData: transformData,
        searchPlaceHolder: searchPlaceHolder,
        contentKey: contentKey
      })]
    });
  });
  ContentComponent.displayName = 'ContentComponent';
  return ContentComponent;
};